import { render, staticRenderFns } from "./NoSubscribers.vue?vue&type=template&id=9cc028b4&scoped=true&"
var script = {}
import style0 from "./NoSubscribers.vue?vue&type=style&index=0&id=9cc028b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc028b4",
  null
  
)

export default component.exports